import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import { TiptapNodeViewContentDirective } from 'ngx-tiptap';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';

@Component({
  selector: 'dojo-draggable-item',
  standalone: true,
  imports: [TiptapNodeViewContentDirective, IconComponent],
  templateUrl: './draggable-item.component.html',
  styleUrls: ['./draggable-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DragWithHandleOnlyDirective],
  providers: [
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => DraggableItemComponent),
    },
  ],
})
export class DraggableItemComponent extends NodeViewComponent<Record<string, never>> {
  readonly isInsideContainer = computed(() => {
    const resolvedPos = this.editor().state.doc.resolve(this.getPos()());
    return resolvedPos.parent.type.name !== 'doc';
  });

  readonly isEditable = computed(() => this.editor().isEditable);

  override getDefaults = (): Record<string, never> => ({});
}
